import { render, staticRenderFns } from "./TariffItem.vue?vue&type=template&id=c833a764&scoped=true"
import script from "./TariffItem.vue?vue&type=script&lang=js"
export * from "./TariffItem.vue?vue&type=script&lang=js"
import style0 from "./TariffItem.vue?vue&type=style&index=0&id=c833a764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c833a764",
  null
  
)

export default component.exports